<div class="engine-wrapper">
  <canvas #rendererCanvas id="renderCanvas"></canvas>
</div>
<div class="menu">
  <table>
    <tr>
      <td>Scena - jpg</td>
      <td><input (change)="uploadScene($event)" type="file" /></td>
    </tr>
    <tr>
      <td>Model</td>
      <td>
        <input (change)="uploadModel($event)" accept="gltf" type="file" />
      </td>
    </tr>
    <tr>
      <td colspan="2">
        <mat-form-field>
          <mat-label>Zdjęcie</mat-label>
          <mat-select #img (valueChange)="updateTexture($event)">
            <mat-option
              value="https://images.unsplash.com/photo-1636118155446-e9ec9187aa1f?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=774&q=80"
            >
              Pion jasny
            </mat-option>
            <mat-option
              value="https://images.unsplash.com/photo-1635967198636-940b9a6947ff?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=774&q=80"
            >
              Pion ciemny
            </mat-option>
            <mat-option
              value="https://images.unsplash.com/photo-1629400713721-1a4b7fd82e59?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=870&q=80"
            >
              Pion zielony
            </mat-option>
            <mat-option
              value="https://images.unsplash.com/photo-1636116461481-4c3ec444c9f8?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1732&q=80"
            >
              Poziom jasny
            </mat-option>
            <mat-option
              value="https://images.unsplash.com/photo-1636063513209-737e96d2b60d?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1740&q=80"
            >
              Poziom ciemny
            </mat-option>
            <mat-option
              value="https://images.unsplash.com/photo-1501520158826-76df880863a3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1740&q=80"
            >
              Poziom zielony
            </mat-option>
          </mat-select>
        </mat-form-field>
      </td>
    </tr>
  </table>
  <div>
    <input #url (change)="updateTexture(url.value)" type="text" />
    <img [src]="img.valueChange | async" />
  </div>
  <lib-button (click)="download()">Pobierz</lib-button>
</div>
